export const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return "N/A";
  const size = Number(bytes);
  if (Number.isNaN(size)) return "N/A";
  if (size === 0) return "0 octet";
  if (size < 1) return `${size} octet`;
  const units = ["octets", "Ko", "Mo", "Go"];
  const index = Math.min(Math.floor(Math.log(size) / Math.log(1024)), units.length - 1);
  const value = size / Math.pow(1024, index);
  return `${value < 10 ? value.toFixed(1) : Math.round(value)} ${units[index]}`;
};

export const formatDate = (value) => {
  if (!value) return "Date inconnue";
  try {
    const date = new Date(value);
    return new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  } catch (e) {
    return value;
  }
};

export const releaseIsEmpty = (release) => {
  if (!release) return true;
  return Object.keys(release).length === 0;
};

export const downloadUrlForRelease = (release) =>
  release?.downloadUrl || "/api/mobile-app/releases/latest/download";
